import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingWebpToJpgConfig } from '@/data/landingConfig/landingWebpToJpgConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_WebpToJpg } from './schemaObject';

interface Props {}
const WebpToJpgConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_WebpToJpg} />
			<LandingTemplate
				data={landingWebpToJpgConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default WebpToJpgConverter;
